import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SharedComponentsService {

  private taskComponentsSubject = new BehaviorSubject<any[]>([]);
  currentTaskComponents = this.taskComponentsSubject.asObservable();
  private projectComponentsSubject = new BehaviorSubject<any[]>([]);
  currentProjectComponents = this.projectComponentsSubject.asObservable();

  setNewComponents(newData: any[], isTask: boolean) {
    console.log(newData)
    if (isTask) {
      this.taskComponentsSubject.next(newData);
    } else {
      this.projectComponentsSubject.next(newData);
    }
  }

  updateComponents(newData: any[], isTask: boolean) {
    if (isTask) {
      this.homogenizeCommonElements(newData, this.projectComponentsSubject.value, isTask);
    } else {
      this.homogenizeCommonElements(newData, this.taskComponentsSubject.value, isTask);
    }
  }


  getComponents(isTask: boolean) {
    if (isTask) {
      return this.currentTaskComponents;
    } else {
      return this.currentProjectComponents;
    }
  }

  homogenizeCommonElements(newComponents: any[], oldComponents: any[], isTask: boolean) {
    const updatedComponents = oldComponents.map(oldItem => {
      const newItem = newComponents.find(item => item.idcomponent === oldItem.idcomponent);
      return newItem ? {...oldItem, ...newItem} : oldItem;
    });
    if (isTask) {
      this.projectComponentsSubject.next(updatedComponents);
    } else {
      this.taskComponentsSubject.next(updatedComponents);
    }
  }

  private flagEditSubject = new BehaviorSubject<number>(0);
  flagEdit$ = this.flagEditSubject.asObservable();
  setFlagEdit(flag: number) { this.flagEditSubject.next(Number(flag) || 0); }


}
